import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApproveFilter from '../../filters/ApproveFilter';
import KTable from '../../components/KTable';
import ApproveModal from '../modals/ApproveModal';
import { Label } from 'reactstrap';
import KPagination from '../../components/KPagination';
import CenterSpinner from '../../components/CenterSpinner';
import {
  externalEmployeeList,
  registrationApprovalSelector,
  resetOnboardingData,
} from '../../features/onboardingSlice';
import {
  API_STATUS,
  CLICK_ACTIONS,
  DEFAULT_PAGE_SIZE,
} from '../../utils/Constant';
import {
  ApprovalFilterType,
  ColumnHeaderType,
  LoggedUserType,
  UserType,
} from '../../utils/Types';
import { updateSelectedCandidate } from '../../features/assignGridSlice';
import KYCVerificationModel from '../modals/KYCModal';
import { updateSelectedMenu } from '../../features/dashboardSlice';
import { loginSelector } from '../../features/loginSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import classNames from 'classnames';
import ToggleSwitch from '../../components/ToggleSwitch';
import { getCandidateRequest, getFilterObject } from './OnboardingPageHelper';
import { useLoader } from '../../loader/LoaderProvider';
interface IOnboardingProps {
  onboardingType: string;
  columnsHeder: any[];
  title: string;
}
const OnboardingPage: React.FunctionComponent<IOnboardingProps> = ({
  onboardingType,
  columnsHeder,
  title,
}) => {
  const [isApproveModalOpen, setIsApproveModalOpen] = useState<boolean>(false);
  const [isKYCModalOpen, setIsKYCModalOpen] = useState<boolean>(false);
  const [initModal, setInitModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { showLoader, setShowLoader } = useLoader();
  const dispatch = useAppDispatch();
  const [selectedCandidateId, setSelectedCandidateId] = useState<number>();
  const [selectedFilter, setSelectedFilter] = useState<any>({});
  const userDataList =
    useAppSelector(registrationApprovalSelector).result ?? [];
  const apiStatus = useAppSelector(registrationApprovalSelector).status;
  const pagination = useAppSelector(registrationApprovalSelector).pagination;
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const [showFilter, setShowFilter] = useState<boolean>(true);

  const navigate = useNavigate();
  /**
   * This method prepare query params find call dispatch
   * to get data for registration approval and KYC verification.
   */
  const getCandidateList = () => {
    if (user?.candidateId) {
      dispatch(
        externalEmployeeList(
          getCandidateRequest(
            onboardingType,
            user,
            userDetails,
            selectedFilter,
            pageSize,
            currentPage
          )
        )
      );
    }
  };
  const applyFilters = (approvalFilter: ApprovalFilterType) => {
    setCurrentPage(1);
    setSelectedFilter(getFilterObject(approvalFilter));
  };
  /**
   * Update show hide status of KYC modal popup.
   * Perform the action the basis of selected actions.
   * @param action
   */
  const toggleKYCModal = (action: string) => {
    if (action === CLICK_ACTIONS.NAVIGATE_TO_ASSIGN_GRID) {
      navigate('/assign-grid');
      dispatch(updateSelectedMenu('assign-grid'));
    } else {
      dispatch(updateSelectedCandidate({}));
      if (action === CLICK_ACTIONS.REFRESH_LIST) {
        getCandidateList();
      }
      if (isKYCModalOpen) {
        setSelectedCandidateId(undefined);
        setTimeout(() => {
          setInitModal(!initModal);
        }, 500);
      } else {
        setInitModal(!initModal);
      }
      setIsKYCModalOpen(!isKYCModalOpen);
    }
  };
  /**
   * Update show hide status of Approval modal popup.
   * Perform the action the basis of selected actions.
   * @param action
   */
  const toggleApproveModal = (action: string) => {
    dispatch(updateSelectedCandidate({}));
    if (action === CLICK_ACTIONS.REFRESH_LIST) {
      getCandidateList();
    }
    if (isApproveModalOpen) {
      setSelectedCandidateId(undefined);
      setTimeout(() => {
        setInitModal(!initModal);
      }, 500);
    } else {
      setInitModal(!initModal);
    }
    setIsApproveModalOpen(!isApproveModalOpen);
  };
  useEffect(() => {
    dispatch(resetOnboardingData());
  }, []);
  useEffect(() => {
    if (userDetails?.roleid) {
      getCandidateList();
    }
  }, [pageSize, currentPage, selectedFilter, user, userDetails]);

  useEffect(() => {
    if (apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else if (
      (apiStatus === API_STATUS.SUCCEEDED || apiStatus === API_STATUS.FAILED) &&
      !isApproveModalOpen &&
      !isKYCModalOpen
    ) {
      setShowLoader(false);
    }
  }, [apiStatus]);
  /**
   *  This method is called form table when user click on any action cell/item
   * @param param Table row data
   * @param headerItem header values for selected cell
   */
  const onTableAction = (param: any, headerItem: ColumnHeaderType) => {
    setSelectedCandidateId(param.candidateId);
    if (headerItem.action === CLICK_ACTIONS.APPROVE) {
      toggleApproveModal(CLICK_ACTIONS.NO_ACTION);
    } else {
      toggleKYCModal(CLICK_ACTIONS.NO_ACTION);
    }
  };

  return (
    <div className="ml-4">
      <Label className="text-heading">{title}</Label>
      <ToggleSwitch
        isOpen={showFilter}
        onClick={() => {
          setShowFilter((prev) => !prev);
        }}
      />
      <div className="task-item-parent-view">
        {showFilter && <ApproveFilter onApplyFilters={applyFilters} />}
        <div className=" mt-2 mt-md-4">
          <KTable
            data={userDataList}
            columnHeader={columnsHeder}
            onAction={onTableAction}
            tableParentClass={classNames('table-parent-onboarding', {
              hideFilters: !showFilter,
            })}
            isLoading={showLoader}
          />
          {userDataList && userDataList.length > 0 && (
            <KPagination
              currentPage={pagination?.currentPage}
              pageSize={pagination?.pageSize}
              onPageChange={setCurrentPage}
              onSizeChange={setPageSize}
              fromItem={pagination?.fromItem}
              toItem={pagination?.toItem}
              totalItems={pagination?.totalItems}
            />
          )}
        </div>
      </div>
      {initModal && (
        <>
          <ApproveModal
            isOpen={isApproveModalOpen}
            toggleApproveModal={(action: string) => {
              toggleApproveModal(action);
            }}
            candidateId={selectedCandidateId}
          />
          <KYCVerificationModel
            isOpen={isKYCModalOpen}
            toggleKYCVerificationModel={toggleKYCModal}
            candidateId={selectedCandidateId}
            refreshData={getCandidateList}
          />
        </>
      )}
      {!isApproveModalOpen && !isKYCModalOpen && (
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      )}
    </div>
  );
};

export default OnboardingPage;
